import { MapContainer, TileLayer } from "react-leaflet";
import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { AustraliaMapProps } from "../../../../../Data/Miscellaneous/Maps/Maps";
import { LeafletAustraliaMap } from "../../../../../utils/Constant";

const AustraliaMap = () => {
  return (
    <Col sm="6">
      <Card>
        <CardHeaderCommon title={LeafletAustraliaMap} borderClass={true} />
        <CardBody>
          <MapContainer className="jvector-map-height z-0" style={{ height: 389 }} {...AustraliaMapProps}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          </MapContainer>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AustraliaMap;
